// extracted by mini-css-extract-plugin
export var mergingIntoPill = "_kx-1";
export var rowFirst = "_kx-3";
export var rowLast = "_kx-5";
export var rowMiddle = "_kx-4";
export var ticketListScroll = "_kx-2";
export var ticketStack = "_kx-0";